// UI strings for the Construnario additions (company activity, contracts,
// company directory). Kept apart from the upstream catalogs so merges from
// Atomic CRM do not conflict.

export const construnarioEnglishMessages = {
  crm: {
    construnario: {
      company_notes: {
        tab: "Activity log |||| Activity log (%{smart_count})",
        empty: "No activity recorded yet.",
        placeholder: "What happened? Call, visit, email, next step...",
        add: "Add activity",
        added: "Activity added",
        added_with_follow_up: "Activity added · follow-up %{when}",
        kind_label: "Kind of activity",
        kind: {
          call: "Call",
          email: "Email",
          visit: "Visit",
          note: "Note",
          contract: "Contract",
        },
        follow_up_label: "Follow up:",
        follow_up: {
          none: "No",
          tomorrow: "Tomorrow",
          week: "In 1 week",
          month: "In 1 month",
        },
        load_more: "Show older",
        by: "by %{name}",
        team: {
          sales: "Sales",
          technical: "Technical",
          marketing: "Marketing",
        },
      },
      contracts: {
        tab: "Contracts |||| Contracts (%{smart_count})",
        empty: "No contracts.",
        year: "Year",
        items: "Items",
        amount: "Amount",
        period: "Period",
        invoice: "Invoice",
        paid: "Paid",
        renewal: "Renewal",
        read_only: "Contracts are edited by the technical team.",
      },
      directory: {
        menu: "Directory",
        title: "Company directory",
        intro:
          "Check whether a company already exists and who handles it. You only see the history of your own companies.",
        search: "Name, tax ID or website",
        min_chars: "Type at least 3 characters.",
        no_results: "No company matches. You can create it.",
        owner: "Handled by",
        no_owner: "Unassigned",
        mine: "Yours",
        open: "Open",
        create: "Create company",
      },
      portfolio: {
        collaborators: "Shared with",
        carp: "construnario.com page",
      },
      renewal: {
        renewed: "Renewed",
        down: "Renewed lower",
        new: "New this year",
        pending: "Not renewed",
        none: "No contract",
      },
      companies: {
        filters: "Quick filters",
        quick: {
          all: "All",
          mine: "Mine",
          pending: "Not renewed",
          down: "Renewed lower",
          new: "New this year",
          shared: "Shared",
          stale: "No activity in 90 days",
        },
        columns: {
          company: "Company",
          owner: "Owner",
          last_note: "Last activity",
          notes: "Activities",
          contract: "Contract %{year}",
          renewal: "Renewal",
          items: "Items",
        },
      },
      web: {
        tab: "Construnario.com",
        range: "Period",
        ranges: {
          "12m": "Last 12 months",
          year: "This year",
          "30d": "Last 30 days",
        },
        loading: "Loading construnario.com statistics…",
        error:
          "Could not load the statistics from construnario.com. Try again in a moment.",
        not_linked: "This company is not linked to a construnario.com client.",
        not_configured:
          "The connection with construnario.com is not set up yet.",
        published: "Page published",
        not_published: "No published page",
        catalogue:
          "%{products} products · %{documents} documents · %{videos} videos",
        open_page: "Open page",
        kpi: {
          visitas: "Visits",
          visitantes: "Visitors",
          producto: "Product views",
          noticia: "News views",
          descarga: "Downloads",
          peticiones: "Information requests",
          contactos: "Price requests (new site)",
          impresiones: "Impressions",
        },
        by_month: "Visits per month",
        top_products: "Most viewed products",
        top_news: "Most read news",
        top_downloads: "Most downloaded files",
        published_news:
          "News published (%{smart_count}) |||| News published (%{smart_count})",
        no_news: "No news published in this period.",
        requests_by_profile:
          "Requests by profile (%{smart_count}) |||| Requests by profile (%{smart_count})",
        latest_requests: "Latest requests",
        no_requests: "No requests in this period.",
        answered: "Answered",
        unanswered: "Not answered",
        empty: "No data in this period.",
        privacy:
          "Requests are shown without the requester's personal data. The full detail is in the construnario.com admin area.",
      },
      my_day: {
        greeting: "Good morning, %{name}",
        days_left:
          "%{smart_count} day left to close the %{next} renewals |||| %{smart_count} days left to close the %{next} renewals",
        contracted: "Contracted %{year}",
        contracted_foot: "%{count} of %{total} companies",
        pending: "Not renewed since %{previous}",
        pending_foot: "%{smart_count} company |||| %{smart_count} companies",
        down: "Renewed lower",
        down_none: "None this year",
        stale: "No activity in %{days} days",
        stale_foot: "Companies to call",
        stale_none: "Every company has recent activity",
        pending_list: "Not renewed",
        pending_list_sub:
          "had a contract in %{previous} and none yet in %{year}",
        pending_empty:
          "Nothing pending: every %{previous} contract is renewed.",
        see_in_list: "See in the list",
        last_note: "last activity %{when}",
        recent_notes: "Latest activity",
        follow_ups: "Follow-ups for today",
        follow_ups_empty:
          "No follow-ups for today. Add one when you log an activity.",
        mark_done: "Mark as done",
        overdue: "due %{when}",
      },
      header: {
        owner: "Handled by",
        contract: "Contract %{year}",
        ends: "Ends",
        last_note: "Last activity",
        summary: "Sales rep summary",
        web_stats: "Website statistics",
      },
      nav: {
        work: "Work",
        portfolio: "Portfolio",
        lookup: "Lookup",
        home: "Home",
      },
      search: {
        placeholder: "Search company, contact or tax ID",
      },
      help: {
        menu: "Help",
        title: "First steps with the CRM",
        intro:
          "Short videos on everyday work. Pick a chapter below to watch it.",
        chapter: "Chapter %{n}",
        all_chapters: "All chapters",
        error: "The videos could not be loaded. Try again in a moment.",
        support: "Questions? Write to soporte@construnario.com.",
        videos: {
          login: {
            title: "Getting into the CRM",
            description:
              "The invitation email, choosing your password, signing in, and what to do if you forget it.",
          },
          my_day: {
            title: "My day: your home screen",
            description:
              "The four key figures, the companies still to renew, today's follow-ups and the latest activity.",
          },
          portfolio: {
            title: "Your company portfolio",
            description:
              "The company table, quick filters and how to find a company.",
          },
          company: {
            title: "The company page",
            description:
              "Header, activity log, contracts, construnario.com statistics and contacts.",
          },
          activity: {
            title: "Logging an activity and a follow-up",
            description:
              "Kind of activity, what happened, when to follow up, and where it shows up afterwards.",
          },
          directory: {
            title: "Does someone handle it? The directory",
            description:
              "Check whether a company exists and who handles it before creating it.",
          },
          full: {
            title: "Full manual",
            description: "The six chapters in a row.",
          },
        },
      },
    },
  },
};

export const construnarioSpanishMessages: typeof construnarioEnglishMessages = {
  crm: {
    construnario: {
      company_notes: {
        tab: "Gestiones |||| Gestiones (%{smart_count})",
        empty: "Todavía no hay gestiones.",
        placeholder:
          "¿Qué ha pasado? Llamada, visita, correo, siguiente paso...",
        add: "Añadir gestión",
        added: "Gestión añadida",
        added_with_follow_up: "Gestión añadida · seguimiento %{when}",
        kind_label: "Tipo de gestión",
        kind: {
          call: "Llamada",
          email: "Correo",
          visit: "Visita",
          note: "Nota",
          contract: "Contrato",
        },
        follow_up_label: "Seguimiento:",
        follow_up: {
          none: "No",
          tomorrow: "Mañana",
          week: "En 1 semana",
          month: "En 1 mes",
        },
        load_more: "Ver anteriores",
        by: "por %{name}",
        team: {
          sales: "Comercial",
          technical: "Técnico",
          marketing: "Marketing",
        },
      },
      contracts: {
        tab: "Contratos |||| Contratos (%{smart_count})",
        empty: "No hay contratos.",
        year: "Año",
        items: "Conceptos",
        amount: "Importe",
        period: "Periodo",
        invoice: "Factura",
        paid: "Cobrado",
        renewal: "Renovación",
        read_only: "Los contratos los edita el equipo técnico.",
      },
      directory: {
        menu: "Directorio",
        title: "Directorio de empresas",
        intro:
          "Comprueba si una empresa ya existe y quién la lleva. Solo ves el historial de tus propias empresas.",
        search: "Nombre, NIF o web",
        min_chars: "Escribe al menos 3 caracteres.",
        no_results: "Ninguna empresa coincide. Puedes darla de alta.",
        owner: "La lleva",
        no_owner: "Sin asignar",
        mine: "Tuya",
        open: "Abrir",
        create: "Nueva empresa",
      },
      portfolio: {
        collaborators: "Compartida con",
        carp: "Ficha en construnario.com",
      },
      renewal: {
        renewed: "Renovado",
        down: "A la baja",
        new: "Nueva este año",
        pending: "Sin renovar",
        none: "Sin contrato",
      },
      companies: {
        filters: "Filtros rápidos",
        quick: {
          all: "Todas",
          mine: "Mías",
          pending: "Sin renovar",
          down: "A la baja",
          new: "Nuevas este año",
          shared: "Compartidas",
          stale: "Sin gestión en 90 días",
        },
        columns: {
          company: "Empresa",
          owner: "Lleva",
          last_note: "Última gestión",
          notes: "Gestiones",
          contract: "Contrato %{year}",
          renewal: "Renovación",
          items: "Conceptos",
        },
      },
      web: {
        tab: "Construnario.com",
        range: "Periodo",
        ranges: {
          "12m": "Últimos 12 meses",
          year: "Este año",
          "30d": "Últimos 30 días",
        },
        loading: "Cargando las estadísticas de construnario.com…",
        error:
          "No se han podido cargar las estadísticas de construnario.com. Inténtalo de nuevo en un momento.",
        not_linked:
          "Esta empresa no está enlazada con un cliente de construnario.com.",
        not_configured:
          "La conexión con construnario.com aún no está configurada.",
        published: "Ficha publicada",
        not_published: "Sin ficha publicada",
        catalogue:
          "%{products} productos · %{documents} documentos · %{videos} vídeos",
        open_page: "Abrir ficha",
        kpi: {
          visitas: "Visitas",
          visitantes: "Visitantes",
          producto: "Visitas a productos",
          noticia: "Visitas a noticias",
          descarga: "Descargas",
          peticiones: "Peticiones de información",
          contactos: "Peticiones de precio (web nueva)",
          impresiones: "Impresiones",
        },
        by_month: "Visitas por mes",
        top_products: "Productos más vistos",
        top_news: "Noticias más leídas",
        top_downloads: "Ficheros más descargados",
        published_news:
          "Noticia publicada (%{smart_count}) |||| Noticias publicadas (%{smart_count})",
        no_news: "No hay noticias publicadas en este periodo.",
        requests_by_profile:
          "Petición por perfil (%{smart_count}) |||| Peticiones por perfil (%{smart_count})",
        latest_requests: "Últimas peticiones",
        no_requests: "No hay peticiones en este periodo.",
        answered: "Respondida",
        unanswered: "Sin responder",
        empty: "Sin datos en este periodo.",
        privacy:
          "Las peticiones se muestran sin los datos personales de quien pregunta. El detalle completo está en la administración de construnario.com.",
      },
      my_day: {
        greeting: "Buenos días, %{name}",
        days_left:
          "queda %{smart_count} día para cerrar las renovaciones de %{next} |||| quedan %{smart_count} días para cerrar las renovaciones de %{next}",
        contracted: "Contratado %{year}",
        contracted_foot: "%{count} de %{total} empresas",
        pending: "Sin renovar desde %{previous}",
        pending_foot: "%{smart_count} empresa |||| %{smart_count} empresas",
        down: "Renovado a la baja",
        down_none: "Ninguna este año",
        stale: "Sin gestión en %{days} días",
        stale_foot: "Empresas a las que llamar",
        stale_none: "Todas tienen gestión reciente",
        pending_list: "Sin renovar",
        pending_list_sub: "tenían contrato en %{previous} y aún no en %{year}",
        pending_empty:
          "Nada pendiente: todos los contratos de %{previous} están renovados.",
        see_in_list: "Ver en el listado",
        last_note: "última gestión %{when}",
        recent_notes: "Últimas gestiones",
        follow_ups: "Seguimientos de hoy",
        follow_ups_empty:
          "No tienes seguimientos para hoy. Se crean al anotar una gestión con fecha.",
        mark_done: "Marcar como hecho",
        overdue: "vencía %{when}",
      },
      header: {
        owner: "Lleva",
        contract: "Contrato %{year}",
        ends: "Vence",
        last_note: "Última gestión",
        summary: "Resumen del comercial",
        web_stats: "Estadísticas web",
      },
      nav: {
        work: "Trabajo",
        portfolio: "Cartera",
        lookup: "Consulta",
        home: "Inicio",
      },
      search: {
        placeholder: "Buscar empresa, contacto o NIF",
      },
      help: {
        menu: "Ayuda",
        title: "Primeros pasos con el CRM",
        intro:
          "Vídeos cortos sobre el trabajo de cada día. Elige un capítulo abajo para verlo.",
        chapter: "Capítulo %{n}",
        all_chapters: "Todos los capítulos",
        error:
          "No se han podido cargar los vídeos. Inténtalo de nuevo en un momento.",
        support: "¿Dudas? Escribe a soporte@construnario.com.",
        videos: {
          login: {
            title: "Entrar en el CRM",
            description:
              "El correo de invitación, elegir la contraseña, iniciar sesión y qué hacer si la olvidas.",
          },
          my_day: {
            title: "Mi día: tu pantalla de inicio",
            description:
              "Las cuatro cifras clave, las empresas por renovar, los seguimientos de hoy y las últimas gestiones.",
          },
          portfolio: {
            title: "Tu cartera de empresas",
            description:
              "La tabla de empresas, los filtros rápidos y cómo encontrar una empresa.",
          },
          company: {
            title: "La ficha de una empresa",
            description:
              "Cabecera, gestiones, contratos, estadísticas de construnario.com y contactos.",
          },
          activity: {
            title: "Anotar una gestión y programar un seguimiento",
            description:
              "Tipo de gestión, qué ha pasado, cuándo volver a llamar y dónde aparece después.",
          },
          directory: {
            title: "¿La lleva alguien? El Directorio",
            description:
              "Comprueba si una empresa existe y quién la lleva antes de darla de alta.",
          },
          full: {
            title: "Manual completo",
            description: "Los seis capítulos seguidos.",
          },
        },
      },
    },
  },
};
